module.exports = __webpack_public_path__ + "img/pocket-15_jp.4a45e6d.jpg";